import { render } from "./LdapTestConnectionModal.vue?vue&type=template&id=20e154c8&scoped=true"
import script from "./LdapTestConnectionModal.vue?vue&type=script&lang=js"
export * from "./LdapTestConnectionModal.vue?vue&type=script&lang=js"

import "./LdapTestConnectionModal.vue?vue&type=style&index=0&id=20e154c8&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e154c8"]])

export default __exports__